import Vue from 'vue'
import axios from 'axios'
//initial state
const state = {
    bsc_name: "○○○○邸",
    bsc_tatekata: "1",
    bsc_type: "1",
    bsc_kyoshitsu_kousei: "1",
    bsc_sonotakyoshitsu: "1",
    bsc_hikyoshitsu: "1",
    bsc_shukyoshitsu_menseki: "29.81",
    bsc_sonotakyoshitsu_menseki: "51.34",
    bsc_nobeyuka_menseki: "120.08",
    bsc_solarlv_specify: "1",
    bsc_solarlv: "",
    env_chiki: "6",
    ip_houhou: "1",
    bsc_sougaihi_menseki: "307.51",
    ip_u_value: "0.87",
    ss_eta_value: "2.8",
    sw_eta_value: "4.3",
    nw_ldk_houhou: "1",
    nw_nldk_houhou: "1",
    sh_nisshanetsuriyo: "1",
    ip_ufv: "1",
    ip_ufv_area_rate: "",
    ip_ufv_dannetsu: "1",
    ip_yuka_dannetsu: "1",
    ip_structure: "1",
    ip_house_dannetsu: "1",
    ip_bath_dannetsu: "2",
    ip_u_roof: "0.240",
    ip_u_wall: "0.530",
    ip_u_door: "2.330",
    ip_u_window: "3.490",
    ip_u_floor_bath: "0.480",
    ip_u_floor_other: "0.480",
    ip_u_base_etrc: "0.480",
    ip_u_base_bath: "0.480",
    ip_u_base_other: "0.480",
    ip_psi_prm_etrc: "1.800",
    ip_psi_prm_bath: "1.800",
    ip_psi_prm_other: "1.800",
    ip_psi_heatbridge_roof: "3.050",
    ip_psi_heatbridge_wall: "3.050",
    ip_psi_heatbridge_floor: "3.050",
    ip_psi_heatbridge_roof_wall: "2.600",
    ip_psi_heatbridge_wall_wall: "2.600",
    ip_psi_heatbridge_wall_floor: "2.600",
    ip_ss_eta_d_window: "0.510",
    ip_sw_eta_d_window: "0.510",
    ip_window_f_input: "1",
    ip_window_ss_f: "0.700",
    ip_window_sw_f: "0.600",
    hs_houhou: "2",
    hs_type: "1",
    hs_dc_duct_dannnetu: "2",
    hs_dc_vav: "1",
    hs_dc_general_ventilation: "2",
    hs_dc_input: "1",
    hs_dc_rated_capacity: "",
    hs_dc_rated_power: "",
    hs_dc_rated_air_flow: "",
    hs_dc_rated_fan_power: "",
    hs_dc_middle_capacity: "",
    hs_dc_middle_power: "",
    hs_dc_middle_air_flow: "",
    hs_dc_middle_fan_power: "",
    hs_dc_input_air_flow: "1",
    hs_dc_air_volume: "",
    hs_ldk_type: "4",
    hs_ldk_other_name: "",
    hs_ldk_aircon_houhou: "1",
    hs_ldk_aircon_koukouritsu: "3",
    hs_ldk_aircon_dualcompressor: "1",
    hs_ldk_ff_houhou: "1",
    hs_ldk_yuka_fukinuke: "1",
    hs_ldk_heater_fukinuke: "1",
    hs_ldk_racfh_fukinuke: "1",
    hs_ldk_racfh_dannetsu_haikan: "2",
    hs_ldk_ff_e: "86.0",
    hs_ldk_yuka_fusetsu_input: "1",
    hs_ldk_yuka_fusetsu: "40.0",
    hs_ldk_yuka_dannetsu: "70",
    hs_ldk_yuka_fukinuke_fusetsu: "",
    hs_ldk_heater_fusetsu_input: "1",
    hs_ldk_heater_fusetsu: "40.0",
    hs_ldk_heater_fukinuke_fusetsu: "",
    hs_ldk_heater_dannetsu: "70",
    hs_ldk_racfh_fusetsu_input: "1",
    hs_ldk_racfh_fusetsu: "40.0",
    hs_ldk_racfh_fukinuke_fusetsu: "",
    hs_ldk_racfh_dannetsu: "70",
    hs_nldk_type: "4",
    hs_nldk_other_name: "",
    hs_nldk_aircon_houhou: "1",
    hs_nldk_aircon_koukouritsu: "3",
    hs_nldk_aircon_dualcompressor: "1",
    hs_nldk_ff_houhou: "1",
    hs_nldk_yuka_fukinuke: "1",
    hs_nldk_heater_fukinuke: "1",
    hs_nldk_racfh_fukinuke: "1",
    hs_nldk_racfh_dannetsu_haikan: "2",
    hs_nldk_ff_e: "86.0",
    hs_nldk_yuka_fusetsu_input: "1",
    hs_nldk_yuka_fusetsu: "40.0",
    hs_nldk_yuka_dannetsu: "70",
    hs_nldk_heater_fusetsu_input: "1",
    hs_nldk_heater_fusetsu: "40.0",
    hs_nldk_heater_dannetsu: "70",
    hs_nldk_racfh_fusetsu_input: "1",
    hs_nldk_racfh_fusetsu: "40.0",
    hs_nldk_racfh_dannetsu: "70",
    hs_onsuiyuka_netsugen_s: "3",
    hs_onsuiyuka_other_name: "",
    hs_onsuiyuka_oil_houhou: "1",
    hs_onsuiyuka_oil_e: "82.0",
    hs_onsuiyuka_gas1_houhou: "1",
    hs_onsuiyuka_gas1_e: "81.0",
    hs_onsuiyuka_dannnetu: "2",
    hs_onsuiyuka_dannnetu_kukaku: "2",
    hs_onsuiyuka_gas2_houhou: "1",
    hs_onsuiyuka_gas2_e: "87.0",
    hs_onsuiyuka_hp_netsukoukan_input: "1",
    hs_onsuiyuka_hp_netsukoukan: "5",
    cs_houhou: "2",
    cs_type: "1",
    cs_dc_duct_dannnetu: "2",
    cs_dc_vav: "1",
    cs_dc_general_ventilation: "2",
    cs_dc_input: "1",
    cs_dc_rated_capacity: "",
    cs_dc_rated_power: "",
    cs_dc_rated_air_flow: "",
    cs_dc_rated_fan_power: "",
    cs_dc_middle_capacity: "",
    cs_dc_middle_power: "",
    cs_dc_middle_air_flow: "",
    cs_dc_middle_fan_power: "",
    cs_dc_input_air_flow: "1",
    cs_dc_air_volume: "",
    cs_ldk_type: "1",
    cs_ldk_other_name: "",
    cs_ldk_type1_houhou: "1",
    cs_ldk_aircon_koukouritsu: "3",
    cs_ldk_aircon_dualcompressor: "1",
    cs_nldk_type: "1",
    cs_nldk_other_name: "",
    cs_nldk_type1_houhou: "1",
    cs_nldk_aircon_koukouritsu: "3",
    cs_nldk_aircon_dualcompressor: "1",
    vn_houshiki: "2",
    vn_freq: "1",
    vn_e: "1.00",
    vn_e_input: "1",
    vn_duct_method: "",
    vn_other_houhou: "1",
    vn_other_hishohidenryoku: "",
    vn_duct_houhou: "1",
    vn_duct_hishohidenryoku: "0.30",
    hw_setti: "1",
    hw_shurui_s: "1",
    hw_other_name: "",
    hw_src_type: "3",
    hw_senyo_sr1_taisaku: "1",
    hw_senyo_sr1_e: "-",
    hw_senyo_sr1_emode: "70.4",
    hw_senyo_sr2_taisaku: "1",
    hw_senyo_sr2_e: "-",
    hw_senyo_sr2_emode: "83.6",
    hw_senyo_sr3_taisaku: "1",
    hw_senyo_sr3_e: "-",
    hw_senyo_sr3_emode: "77.9",
    hw_senyo_sr4_taisaku: "1",
    hw_senyo_sr4_e: "-",
    hw_senyo_sr4_emode: "81.9",
    hw_senyo_sr6_spec_method: "1",
    hw_senyo_sr6_e: "2.7",
    hw_senyo_sr6_P_HP_imd_std: "",
    hw_senyo_sr6_P_HP_sum_std: "",
    hw_senyo_sr6_P_HP_win_std: "",
    hw_senyo_sr6_q_HP_imd_std: "",
    hw_senyo_sr6_q_HP_sum_std: "",
    hw_senyo_sr6_q_HP_win_std: "",
    hw_senyo_sr6_e_HP_def_high: "",
    hw_senyo_sr6_e_HP_frst_high: "",
    hw_senyo_sr6_theta_bw_frst_high: "",
    hw_senyo_sr6_theta_bw_imd_std: "",
    hw_senyo_sr6_theta_bw_sum_std: "",
    hw_senyo_sr6_theta_bw_win_std: "",
    hw_senyo_sr6_A_p: "",
    hw_senyo_sr6_B_p: "",
    hw_senyo_sr6_P_aux_HP_on: "",
    hw_senyo_sr6_P_aux_HP_off: "",
    hw_senyo_sr6_Q_loss: "",
    hw_senyo_sr6_R_tnk: "",
    hw_senyo_sr6_theta_hat_bw_win_cm_first: "",
    hw_senyo_sr6_theta_hat_bw_win_cm_second: "",
    hw_senyo_sr7_package_input: "2",
    hw_senyo_sr7_package_id: "",
    hw_senyo_sr7_coolant_type: "1",
    hw_senyo_sr7_tank: "1",
    hw_ittai_sr11_taisaku: "1",
    hw_ittai_sr11_heater_e: "81.0",
    hw_ittai_sr11_hotwater_e: "",
    hw_ittai_sr11_hotwater_emode: "70.4",
    hw_ittai_sr12_taisaku: "1",
    hw_ittai_sr12_heater_e: "87.0",
    hw_ittai_sr12_hotwater_e: "",
    hw_ittai_sr12_hotwater_emode: "83.6",
    hw_ittai_sr13_taisaku: "1",
    hw_ittai_sr13_heater_e: "82.0",
    hw_ittai_sr13_hotwater_e: "-",
    hw_ittai_sr13_hotwater_emode: "77.9",
    hw_ittai_sr14_taisaku: "1",
    hw_ittai_sr14_hotwater_e: "-",
    hw_ittai_sr14_hotwater_emode: "81.9",
    hw_ittai_sr16_tank: "2",
    hw_ittai_sr17_kubun: "1",
    hw_ittai_sr18_package_input: "2",
    hw_ittai_sr18_package_id: "",
    hw_ittai_sr18_coolant_type: "1",
    hw_ittai_sr18_tank: "1",
    hw_hybrid_a_HP: "",
    hw_hybrid_b_HP: "",
    hw_hybrid_a_TU: "",
    hw_hybrid_b_TU: "",
    hw_hybrid_eta_loss_TU: "",
    hw_hybrid_e_BB_jis: "",
    hw_hybrid_e_HPstd_m7: "",
    hw_hybrid_e_HPstd_2: "",
    hw_hybrid_e_HPstd_7: "",
    hw_hybrid_e_HPstd_25: "",
    hw_hybrid_Q_HP_max: "",
    hw_hybrid_theta_ex_min_HP: "",
    hw_hybrid_R_day: "",
    hw_daidokoro_suisen: "1",
    hw_shower_suisen: "1",
    hw_senmen_suisen: "1",
    hw_yokuso_hoon: "1",
    hw_header_type: "1",
    hw_pipesize: "",
    hw_daidokoro_temoto: "",
    hw_daidokoro_yusen: "",
    hw_shower_temoto: "",
    hw_shower_shoryuryo: "",
    hw_senmen_yusen: "",
    hybridwaterheater_senyo_filter:"",
    hybridwaterheater_ittai_filter:"",
    electricHeatPumpFilter:"",
    ls_main_setti: "1",
    ls_main_design: "",
    ls_main_multi: "1",
    ls_main_dimming: "2",
    ls_general_setti: "1",
    ls_general_device: "",
    ls_general_dimming: "2",
    ls_other_setti: "1",
    ls_other_device: "",
    ls_other_control: "2",
    hv_houshiki: "2",
    hv_houhou: "1",
    hv_eff: "40",
    hv_correction_input: "1",
    hv_bal: "0.90",
    hv_leak: "1.00",
    pv_saiyou: "2",
    pv_houhou: "1",
    pv_panelsuu: "1",
    pv_panel1_youryo: "2.00",
    pv_panel1_shurui: "1",
    pv_panel1_setti: "2",
    pv_panel1_houi: "1",
    pv_panel1_keisha: "4",
    pv_panel2_youryo: "2.00",
    pv_panel2_shurui: "1",
    pv_panel2_setti: "2",
    pv_panel2_houi: "1",
    pv_panel2_keisha: "4",
    pv_panel3_youryo: "2.00",
    pv_panel3_shurui: "1",
    pv_panel3_setti: "2",
    pv_panel3_houi: "1",
    pv_panel3_keisha: "4",
    pv_panel4_youryo: "2.00",
    pv_panel4_shurui: "1",
    pv_panel4_setti: "2",
    pv_panel4_houi: "1",
    pv_panel4_keisha: "4",
    pv_pcs_koritsu: "1",
    pv_pcs_koritsu_e: "92.7",
    sw_saiyou: "2",
    sw_houhou: "1",
    sw_sr: "",
    sw_sr1_menseki: "1",
    sw_sr1_menseki_all: "",
    sw_sr1_menseki_eff: "",
    sw_sr1_angle: "",
    sw_sr1_slope: "4",
    sw_sr2_menseki: "1",
    sw_sr2_menseki_all: "",
    sw_sr2_menseki_eff: "",
    sw_sr2_angle: "",
    sw_sr2_slope: "4",
    sw_sr2_tankyouryo: "",
    om_saiyou: "2",
    om_houhou: "1",
    om_panelsuu: "1",
    om_panel_houi: "1",
    om_fan_jirituunten: "2",
    om_fan_type: "2",
    om_hw_saiyou: "2",
    om_pump_jirituunten: "2",
    om_tankyouryo: "",
    om_fan_test: "",
    om_panel1_menseki: "",
    om_panel1_keisha: "4",
    om_panel1_input: "2",
    om_panel1_d0: "0.1",
    om_panel1_d1: "2.0",
    om_panel1_mfan: "0.0107",
    om_panel2_menseki: "",
    om_panel2_keisha: "4",
    om_panel2_input: "2",
    om_panel2_d0: "0.1",
    om_panel2_d1: "2.0",
    om_panel2_mfan: "0.0107",
    om_panel3_menseki: "",
    om_panel3_keisha: "4",
    om_panel3_input: "2",
    om_panel3_d0: "0.1",
    om_panel3_d1: "2.0",
    om_panel3_mfan: "0.0107",
    om_panel4_menseki: "",
    om_panel4_keisha: "4",
    om_panel4_input: "2",
    om_panel4_d0: "0.1",
    om_panel4_d1: "2.0",
    om_panel4_mfan: "0.0107",
    om_supply_target: "1",
    om_ufv_area_rate: "",
    om_ufv_dannetsu: "1",
    use_cogen: "1",
    cogen_houhou: "1",
    cogen_type: "1",
    cogen_houshiki: "",
    cogen_reverse: "1",
    cogen_package_input: "1",
    cogen_pefc_filter: "",
    cogen_pefc_package_filter: "",
    cogen_pefc_package_id: "",
    cogen_sofc_package_input: "1",
    cogen_sofc_category: "",
    cogen_sofc_filter: "",
    cogen_sofc_package_filter: "",
    cogen_sofc_package_id: "",
    cogen_gec_package_input: "1",
    cogen_gec_category: "",
    cogen_type_param: "",
    cogen_pu_kasou_pgen_coef_a_PU: "",
    cogen_pu_kasou_pgen_coef_a_DHW: "",
    cogen_pu_kasou_pgen_coef_a_HWH: "",
    cogen_pu_kasou_pgen_coef_b: "",
    cogen_pu_kasou_pgen_coef_c: "",
    cogen_pu_kasou_fcost_coef_a_DHW: "",
    cogen_pu_kasou_fcost_coef_a_HWH: "",
    cogen_pu_kasou_fmax_coef_a_DHW: "",
    cogen_pu_kasou_fmax_coef_a_HWH: "",
    cogen_pu_kasou_fmax_coef_b: "",
    cogen_pu_pgen_koritsu_coef_a_PU: "",
    cogen_pu_pgen_koritsu_coef_a_DHW: "",
    cogen_pu_pgen_koritsu_coef_a_HWH: "",
    cogen_pu_pgen_koritsu_coef_b: "",
    cogen_pu_pgen_koritsu_upper_limit: "",
    cogen_pu_pgen_koritsu_lower_limit: "",
    cogen_pu_hainetsu_kouritsu_coef_a_PU: "",
    cogen_pu_hainetsu_kouritsu_coef_a_DHW: "",
    cogen_pu_hainetsu_kouritsu_coef_a_HWH: "",
    cogen_pu_hainetsu_kouritsu_coef_b: "",
    cogen_pu_hainetsu_kouritsu_upper_limit: "",
    cogen_pu_hainetsu_kouritsu_lower_limit: "",
    cogen_bb_type: "1",
    cogen_bb_hotwater_koritsu: "",
    cogen_bb_rated_efficiency: "",
    cogen_bb_rated_capacity: "",
    cogen_hainetsu_use: "1",
    cogen_hainetsu_use_type: "1",
    cogen_pu_hw_hainetu_use: "",
    cogen_pu_hs_hainetu_use: "",
    cogen_tu_hw_sub_pcost: "",
    cogen_tu_hs_sub_pcost: "",
    cogen_rated_pgen: "",
    cogen_reverse_type: "1",
    mode: '',
    // 開発者確認用データ
    // TODO: 機能が実装されたら消す
    devString: null,
    devSelectedFile: null,
}

//getters
const getters = {
    /**
     * Storeで保持している計算手法を返す
     */
    getMode(state) {
        return state.mode
    },
    /**
     * コジェネに関する情報を返す
     */
    getCogenState(state) {
        return {
            use_cogen: state.use_cogen,
            cogen_type: state.cogen_type,
            cogen_pefc_package_input: state.cogen_pefc_package_input,
            cogen_pefc_package_id: state.cogen_pefc_package_id,
            cogen_pefc_category: state.cogen_pefc_category,
            cogen_reverse: state.cogen_reverse,
            cogen_pefc_filter: state.cogen_pefc_filter,
            cogen_sofc_package_input: state.cogen_sofc_package_input,
            cogen_sofc_package_id: state.cogen_sofc_package_id,
            cogen_sofc_category: state.cogen_sofc_category,
            cogen_sofc_filter: state.cogen_sofc_filter,
            cogen_gec_package_input: state.cogen_gec_package_input,
            cogen_gec_category: state.cogen_gec_category,
            cogen_type_param:state.cogen_type_param,
            cogen_pu_kasou_pgen_coef_a_PU:state.cogen_pu_kasou_pgen_coef_a_PU,
            cogen_pu_kasou_pgen_coef_a_DHW:state.cogen_pu_kasou_pgen_coef_a_DHW,
            cogen_pu_kasou_pgen_coef_a_HWH:state.cogen_pu_kasou_pgen_coef_a_HWH,
            cogen_pu_kasou_pgen_coef_b:state.cogen_pu_kasou_pgen_coef_b,
            cogen_pu_kasou_pgen_coef_c:state.cogen_pu_kasou_pgen_coef_c,
            cogen_pu_kasou_fcost_coef_a_DHW:state.cogen_pu_kasou_fcost_coef_a_DHW,
            cogen_pu_kasou_fcost_coef_a_HWH:state.cogen_pu_kasou_fcost_coef_a_HWH,
            cogen_pu_kasou_fmax_coef_a_DHW:state.cogen_pu_kasou_fmax_coef_a_DHW,
            cogen_pu_kasou_fmax_coef_a_HWH:state.cogen_pu_kasou_fmax_coef_a_HWH,
            cogen_pu_kasou_fmax_coef_b:state.cogen_pu_kasou_fmax_coef_b,
            cogen_pu_pgen_koritsu_coef_a_PU:state.cogen_pu_pgen_koritsu_coef_a_PU,
            cogen_pu_pgen_koritsu_coef_a_DHW:state.cogen_pu_pgen_koritsu_coef_a_DHW,
            cogen_pu_pgen_koritsu_coef_a_HWH:state.cogen_pu_pgen_koritsu_coef_a_HWH,
            cogen_pu_pgen_koritsu_coef_b:state.cogen_pu_pgen_koritsu_coef_b,
            cogen_pu_pgen_koritsu_upper_limit:state.cogen_pu_pgen_koritsu_upper_limit,
            cogen_pu_pgen_koritsu_lower_limit:state.cogen_pu_pgen_koritsu_lower_limit,
            cogen_pu_hainetsu_kouritsu_coef_a_PU:state.cogen_pu_hainetsu_kouritsu_coef_a_PU,
            cogen_pu_hainetsu_kouritsu_coef_a_DHW:state.cogen_pu_hainetsu_kouritsu_coef_a_DHW,
            cogen_pu_hainetsu_kouritsu_coef_a_HWH:state.cogen_pu_hainetsu_kouritsu_coef_a_HWH,
            cogen_pu_hainetsu_kouritsu_coef_b:state.cogen_pu_hainetsu_kouritsu_coef_b,
            cogen_pu_hainetsu_kouritsu_upper_limit:state.cogen_pu_hainetsu_kouritsu_upper_limit,
            cogen_pu_hainetsu_kouritsu_lower_limit:state.cogen_pu_hainetsu_kouritsu_lower_limit,
            cogen_bb_netsugen_type:state.cogen_bb_netsugen_type,
            cogen_bb_hotwater_koritsu:state.cogen_bb_hotwater_koritsu,
            cogen_bb_type:state.cogen_bb_type,
            cogen_bb_rated_efficiency:state.cogen_bb_rated_efficiency,
            cogen_bb_rated_capacity:state.cogen_bb_rated_capacity,
            cogen_hainetsu_use:state.cogen_hainetsu_use,
            cogen_hainetsu_use_type:state.cogen_hainetsu_use_type,
            cogen_pu_hw_hainetu_use:state.cogen_pu_hw_hainetu_use,
            cogen_pu_hs_hainetu_use:state.cogen_pu_hs_hainetu_use,
            cogen_tu_hw_sub_pcost:state.cogen_tu_hw_sub_pcost,
            cogen_tu_hs_sub_pcost:state.cogen_tu_hs_sub_pcost,
            cogen_rated_pgen:state.cogen_rated_pgen,
            cogen_reverse_type:state.cogen_reverse_type,
        }
    },
    /**
     * Pefcの検索文を返す
     */
    getCogenPefcFilter(state) {
        return state.cogen_pefc_filter
    },
    /**
     * Sofcの検索文を返す
     */
    getCogenSofcFilter(state) {
        return state.cogen_sofc_filter
    },
    /**
     * 給湯専用型:電気ヒートポンプ・ガス瞬間式併用型給湯機の検索文を返す
     */
    getHybridwaterheaterSenyoFilter(state) {
        return state.hybridwaterheater_senyo_filter
    },
    /**
     * 給湯・温水暖房一体型:電気ヒートポンプ・ガス瞬間式併用型給湯機の検索文を返す
     */
    getHybridwaterheaterIttaiFilter(state) {
        return state.hybridwaterheater_ittai_filter
    },
    /**
     * 電気ヒートポンプの検索文を返す
     */
    getElectricHeatPumpFilter(state) {
        return state.electricHeatPumpFilter
    },
    /**
     * State全体を返す
     */
    getData(state) {
        return state
    },
}

//actions
const actions = {
    /**
     * stateの項目を指定して更新
     */
    update({ commit }, values) {
        commit('update', values)
    },
    /**
     * stateの一括更新
     */
    load({ commit }, data) {
        commit('load', data)
    },
    /**
     * stateの初期化
     */
    reset({ commit }) {
        const data = {
            bsc_name: "○○○○邸",
            bsc_tatekata: "1",
            bsc_type: "1",
            bsc_kyoshitsu_kousei: "1",
            bsc_sonotakyoshitsu: "1",
            bsc_hikyoshitsu: "1",
            bsc_shukyoshitsu_menseki: "29.81",
            bsc_sonotakyoshitsu_menseki: "51.34",
            bsc_nobeyuka_menseki: "120.08",
            bsc_solarlv_specify: "1",
            bsc_solarlv: "",
            env_chiki: "6",
            ip_houhou: "1",
            bsc_sougaihi_menseki: "307.51",
            ip_u_value: "0.87",
            ss_eta_value: "2.8",
            sw_eta_value: "4.3",
            nw_ldk_houhou: "1",
            nw_nldk_houhou: "1",
            sh_nisshanetsuriyo: "1",
            ip_ufv: "1",
            ip_ufv_area_rate: "",
            ip_ufv_dannetsu: "1",
            ip_yuka_dannetsu: "1",
            ip_structure: "1",
            ip_house_dannetsu: "1",
            ip_bath_dannetsu: "2",
            ip_u_roof: "0.240",
            ip_u_wall: "0.530",
            ip_u_door: "2.330",
            ip_u_window: "3.490",
            ip_u_floor_bath: "0.480",
            ip_u_floor_other: "0.480",
            ip_u_base_etrc: "0.480",
            ip_u_base_bath: "0.480",
            ip_u_base_other: "0.480",
            ip_psi_prm_etrc: "1.800",
            ip_psi_prm_bath: "1.800",
            ip_psi_prm_other: "1.800",
            ip_psi_heatbridge_roof: "3.050",
            ip_psi_heatbridge_wall: "3.050",
            ip_psi_heatbridge_floor: "3.050",
            ip_psi_heatbridge_roof_wall: "2.600",
            ip_psi_heatbridge_wall_wall: "2.600",
            ip_psi_heatbridge_wall_floor: "2.600",
            ip_ss_eta_d_window: "0.510",
            ip_sw_eta_d_window: "0.510",
            ip_window_f_input: "1",
            ip_window_ss_f: "0.700",
            ip_window_sw_f: "0.600",
            hs_houhou: "2",
            hs_type: "1",
            hs_dc_duct_dannnetu: "2",
            hs_dc_vav: "1",
            hs_dc_general_ventilation: "2",
            hs_dc_input: "1",
            hs_dc_rated_capacity: "",
            hs_dc_rated_power: "",
            hs_dc_rated_air_flow: "",
            hs_dc_rated_fan_power: "",
            hs_dc_middle_capacity: "",
            hs_dc_middle_power: "",
            hs_dc_middle_air_flow: "",
            hs_dc_middle_fan_power: "",
            hs_dc_input_air_flow: "1",
            hs_dc_air_volume: "",
            hs_ldk_type: "4",
            hs_ldk_other_name: "",
            hs_ldk_aircon_houhou: "1",
            hs_ldk_aircon_koukouritsu: "3",
            hs_ldk_aircon_dualcompressor: "1",
            hs_ldk_ff_houhou: "1",
            hs_ldk_yuka_fukinuke: "1",
            hs_ldk_heater_fukinuke: "1",
            hs_ldk_racfh_fusetsu_input: "1",
            hs_ldk_racfh_fukinuke: "1",
            hs_ldk_racfh_dannetsu_haikan: "2",
            hs_ldk_ff_e: "86.0",
            hs_ldk_yuka_fusetsu_input: "1",
            hs_ldk_yuka_fusetsu: "40.0",
            hs_ldk_yuka_dannetsu: "70",
            hs_ldk_yuka_fukinuke_fusetsu: "",
            hs_ldk_heater_fusetsu_input: "1",
            hs_ldk_heater_fusetsu: "40.0",
            hs_ldk_heater_fukinuke_fusetsu: "",
            hs_ldk_heater_dannetsu: "70",
            hs_ldk_racfh_fusetsu: "40.0",
            hs_ldk_racfh_fukinuke_fusetsu: "",
            hs_ldk_racfh_dannetsu: "70",
            hs_nldk_type: "4",
            hs_nldk_other_name: "",
            hs_nldk_aircon_houhou: "1",
            hs_nldk_aircon_koukouritsu: "3",
            hs_nldk_aircon_dualcompressor: "1",
            hs_nldk_ff_houhou: "1",
            hs_nldk_yuka_fukinuke: "1",
            hs_nldk_heater_fukinuke: "1",
            hs_nldk_racfh_fukinuke: "1",
            hs_nldk_racfh_dannetsu_haikan: "2",
            hs_nldk_ff_e: "86.0",
            hs_nldk_yuka_fusetsu_input: "1",
            hs_nldk_yuka_fusetsu: "40.0",
            hs_nldk_yuka_dannetsu: "70",
            hs_nldk_heater_fusetsu_input: "1",
            hs_nldk_heater_fusetsu: "40.0",
            hs_nldk_heater_dannetsu: "70",
            hs_nldk_racfh_fusetsu_input: "1",
            hs_nldk_racfh_fusetsu: "40.0",
            hs_nldk_racfh_dannetsu: "70",
            hs_onsuiyuka_netsugen_s: "3",
            hs_onsuiyuka_other_name: "",
            hs_onsuiyuka_oil_houhou: "1",
            hs_onsuiyuka_oil_e: "82.0",
            hs_onsuiyuka_gas1_houhou: "1",
            hs_onsuiyuka_gas1_e: "81.0",
            hs_onsuiyuka_dannnetu: "2",
            hs_onsuiyuka_dannnetu_kukaku: "2",
            hs_onsuiyuka_gas2_houhou: "1",
            hs_onsuiyuka_gas2_e: "87.0",
            hs_onsuiyuka_hp_netsukoukan: "5",
            cs_houhou: "2",
            cs_type: "1",
            cs_dc_duct_dannnetu: "2",
            cs_dc_vav: "1",
            cs_dc_general_ventilation: "2",
            cs_dc_input: "1",
            cs_dc_rated_capacity: "",
            cs_dc_rated_power: "",
            cs_dc_rated_air_flow: "",
            cs_dc_rated_fan_power: "",
            cs_dc_middle_capacity: "",
            cs_dc_middle_power: "",
            cs_dc_middle_air_flow: "",
            cs_dc_middle_fan_power: "",
            cs_dc_input_air_flow: "1",
            cs_dc_air_volume: "",
            cs_ldk_type: "1",
            cs_ldk_other_name: "",
            cs_ldk_type1_houhou: "1",
            cs_ldk_aircon_koukouritsu: "3",
            cs_ldk_aircon_dualcompressor: "1",
            cs_nldk_type: "1",
            cs_nldk_other_name: "",
            cs_nldk_type1_houhou: "1",
            cs_nldk_aircon_koukouritsu: "3",
            cs_nldk_aircon_dualcompressor: "1",
            vn_houshiki: "2",
            vn_freq: "1",
            vn_e: "1.00",
            vn_duct_method: "",
            vn_other_houhou: "1",
            vn_other_hishohidenryoku: "",
            vn_duct_houhou: "1",
            vn_duct_hishohidenryoku: "0.30",
            vn_e_input: "1",
            hw_setti: "1",
            hw_shurui_s: "1",
            hw_other_name: "",
            hw_src_type: "3",
            hw_senyo_sr1_taisaku: "1",
            hw_senyo_sr1_e: "-",
            hw_senyo_sr1_emode: "70.4",
            hw_senyo_sr2_taisaku: "1",
            hw_senyo_sr2_e: "-",
            hw_senyo_sr2_emode: "83.6",
            hw_senyo_sr3_taisaku: "1",
            hw_senyo_sr3_e: "-",
            hw_senyo_sr3_emode: "77.9",
            hw_senyo_sr4_taisaku: "1",
            hw_senyo_sr4_e: "-",
            hw_senyo_sr4_emode: "81.9",
            hw_senyo_sr6_spec_method: "1",
            hw_senyo_sr6_e: "2.7",
            hw_senyo_sr6_P_HP_imd_std: "",
            hw_senyo_sr6_P_HP_sum_std: "",
            hw_senyo_sr6_P_HP_win_std: "",
            hw_senyo_sr6_q_HP_imd_std: "",
            hw_senyo_sr6_q_HP_sum_std: "",
            hw_senyo_sr6_q_HP_win_std: "",
            hw_senyo_sr6_e_HP_def_high: "",
            hw_senyo_sr6_e_HP_frst_high: "",
            hw_senyo_sr6_theta_bw_frst_high: "",
            hw_senyo_sr6_theta_bw_imd_std: "",
            hw_senyo_sr6_theta_bw_sum_std: "",
            hw_senyo_sr6_theta_bw_win_std: "",
            hw_senyo_sr6_A_p: "",
            hw_senyo_sr6_B_p: "",
            hw_senyo_sr6_P_aux_HP_on: "",
            hw_senyo_sr6_P_aux_HP_off: "",
            hw_senyo_sr6_Q_loss: "",
            hw_senyo_sr6_R_tnk: "",
            hw_senyo_sr6_theta_hat_bw_win_cm_first: "",
            hw_senyo_sr6_theta_hat_bw_win_cm_second: "",        
            hw_senyo_sr7_package_input: "2",
            hw_senyo_sr7_package_id: "",
            hw_senyo_sr7_coolant_type: "1",
            hw_senyo_sr7_tank: "1",
            hw_ittai_sr11_taisaku: "1",
            hw_ittai_sr11_heater_e: "81.0",
            hw_ittai_sr11_hotwater_e: "",
            hw_ittai_sr11_hotwater_emode: "70.4",
            hw_ittai_sr12_taisaku: "1",
            hw_ittai_sr12_heater_e: "87.0",
            hw_ittai_sr12_hotwater_e: "",
            hw_ittai_sr12_hotwater_emode: "83.6",
            hw_ittai_sr13_taisaku: "1",
            hw_ittai_sr13_heater_e: "82.0",
            hw_ittai_sr13_hotwater_e: "-",
            hw_ittai_sr13_hotwater_emode: "77.9",
            hw_ittai_sr14_taisaku: "1",
            hw_ittai_sr14_hotwater_e: "-",
            hw_ittai_sr14_hotwater_emode: "81.9",
            hw_ittai_sr16_tank: "2",
            hw_ittai_sr17_kubun: "1",
            hw_ittai_sr18_package_input: "2",
            hw_ittai_sr18_package_id: "",
            hw_ittai_sr18_coolant_type: "1",
            hw_ittai_sr18_tank: "1",
            hw_hybrid_a_HP: "",
            hw_hybrid_b_HP: "",
            hw_hybrid_a_TU: "",
            hw_hybrid_b_TU: "",
            hw_hybrid_eta_loss_TU: "",
            hw_hybrid_e_BB_jis: "",
            hw_hybrid_e_HPstd_m7: "",
            hw_hybrid_e_HPstd_2: "",
            hw_hybrid_e_HPstd_7: "",
            hw_hybrid_e_HPstd_25: "",
            hw_hybrid_Q_HP_max: "",
            hw_hybrid_theta_ex_min_HP: "",
            hw_hybrid_R_day: "",        
            hw_daidokoro_suisen: "1",
            hw_shower_suisen: "1",
            hw_senmen_suisen: "1",
            hw_yokuso_hoon: "1",
            hw_header_type: "1",
            hw_pipesize: "",
            hw_daidokoro_temoto: "",
            hw_daidokoro_yusen: "",
            hw_shower_temoto: "",
            hw_shower_shoryuryo: "",
            hw_senmen_yusen: "",
            ls_main_setti: "1",
            ls_main_design: "",
            ls_main_multi: "1",
            ls_main_dimming: "2",
            ls_general_setti: "1",
            ls_general_device: "",
            ls_general_dimming: "2",
            ls_other_setti: "1",
            ls_other_device: "",
            ls_other_control: "2",
            hv_houshiki: "2",
            hv_houhou: "1",
            hv_eff: "40",
            hv_correction_input: "1",
            hv_bal: "0.90",
            hv_leak: "1.00",
            pv_saiyou: "2",
            pv_houhou: "1",
            pv_panelsuu: "1",
            pv_panel1_youryo: "2.00",
            pv_panel1_shurui: "1",
            pv_panel1_setti: "2",
            pv_panel1_houi: "1",
            pv_panel1_keisha: "4",
            pv_panel2_youryo: "2.00",
            pv_panel2_shurui: "1",
            pv_panel2_setti: "2",
            pv_panel2_houi: "1",
            pv_panel2_keisha: "4",
            pv_panel3_youryo: "2.00",
            pv_panel3_shurui: "1",
            pv_panel3_setti: "2",
            pv_panel3_houi: "1",
            pv_panel3_keisha: "4",
            pv_panel4_youryo: "2.00",
            pv_panel4_shurui: "1",
            pv_panel4_setti: "2",
            pv_panel4_houi: "1",
            pv_panel4_keisha: "4",
            pv_pcs_koritsu: "1",
            pv_pcs_koritsu_e: "92.7",
            sw_saiyou: "2",
            sw_houhou: "1",
            sw_sr: "",
            sw_sr1_menseki: "1",
            sw_sr1_menseki_all: "",
            sw_sr1_menseki_eff: "",
            sw_sr1_angle: "",
            sw_sr1_slope: "4",
            sw_sr2_menseki: "1",
            sw_sr2_menseki_all: "",
            sw_sr2_menseki_eff: "",
            sw_sr2_angle: "",
            sw_sr2_slope: "4",
            sw_sr2_tankyouryo: "",
            om_saiyou: "2",
            om_houhou: "1",
            om_panelsuu: "1",
            om_panel_houi: "1",
            om_fan_jirituunten: "2",
            om_fan_type: "2",
            om_hw_saiyou: "2",
            om_pump_jirituunten: "2",
            om_tankyouryo: "",
            om_fan_test: "",
            om_panel1_menseki: "",
            om_panel1_keisha: "4",
            om_panel1_input: "2",
            om_panel1_d0: "0.1",
            om_panel1_d1: "2.0",
            om_panel1_mfan: "0.0107",
            om_panel2_menseki: "",
            om_panel2_keisha: "4",
            om_panel2_input: "2",
            om_panel2_d0: "0.1",
            om_panel2_d1: "2.0",
            om_panel2_mfan: "0.0107",
            om_panel3_menseki: "",
            om_panel3_keisha: "4",
            om_panel3_input: "2",
            om_panel3_d0: "0.1",
            om_panel3_d1: "2.0",
            om_panel3_mfan: "0.0107",
            om_panel4_menseki: "",
            om_panel4_keisha: "4",
            om_panel4_input: "2",
            om_panel4_d0: "0.1",
            om_panel4_d1: "2.0",
            om_panel4_mfan: "0.0107",
            om_supply_target: "1",
            om_ufv_area_rate: "",
            om_ufv_dannetsu: "1",
            use_cogen: "1",
            cogen_houhou: "1",
            cogen_type: "1",
            cogen_houshiki: "",
            cogen_reverse: "1",
            cogen_package_input: "1",
            cogen_pefc_filter: "",
            cogen_pefc_package_id: "",
            cogen_sofc_package_input: "1",
            cogen_sofc_category: "",
            cogen_sofc_filter: "",
            cogen_sofc_package_id: "",
            cogen_gec_package_input: "1",
            cogen_gec_category: "",
            cogen_type_param: "",
            cogen_pu_kasou_pgen_coef_a_PU: "",
            cogen_pu_kasou_pgen_coef_a_DHW: "",
            cogen_pu_kasou_pgen_coef_a_HWH: "",
            cogen_pu_kasou_pgen_coef_b: "",
            cogen_pu_kasou_pgen_coef_c: "",
            cogen_pu_kasou_fcost_coef_a_DHW: "",
            cogen_pu_kasou_fcost_coef_a_HWH: "",
            cogen_pu_kasou_fmax_coef_a_DHW: "",
            cogen_pu_kasou_fmax_coef_a_HWH: "",
            cogen_pu_kasou_fmax_coef_b: "",
            cogen_pu_pgen_koritsu_coef_a_PU: "",
            cogen_pu_pgen_koritsu_coef_a_DHW: "",
            cogen_pu_pgen_koritsu_coef_a_HWH: "",
            cogen_pu_pgen_koritsu_coef_b: "",
            cogen_pu_pgen_koritsu_upper_limit: "",
            cogen_pu_pgen_koritsu_lower_limit: "",
            cogen_pu_hainetsu_kouritsu_coef_a_PU: "",
            cogen_pu_hainetsu_kouritsu_coef_a_DHW: "",
            cogen_pu_hainetsu_kouritsu_coef_a_HWH: "",
            cogen_pu_hainetsu_kouritsu_coef_b: "",
            cogen_pu_hainetsu_kouritsu_upper_limit: "",
            cogen_pu_hainetsu_kouritsu_lower_limit: "",
            cogen_bb_netsugen_type: "1",
            cogen_bb_hotwater_koritsu: "",
            cogen_bb_type: "1",
            cogen_bb_rated_efficiency: "",
            cogen_bb_rated_capacity: "",
            cogen_hainetsu_use: "1",
            cogen_hainetsu_use_type: "1",
            cogen_pu_hw_hainetu_use: "",
            cogen_pu_hs_hainetu_use: "",
            cogen_tu_hw_sub_pcost: "",
            cogen_tu_hs_sub_pcost: "",
            cogen_rated_pgen: "",
            cogen_reverse_type: "1",
            cogen_pefc_package_filter:"",
            cogen_sofc_package_filter:"",
            mode: '',
        }
        commit('load', data)
    },
    /**
     * 簡易→詳細遷移直後の計算結果を一致させるため、stateに一括で簡易デフォルト値を追加
     */
    simpleToDetail({ state, commit }) {
        commit('update', { mode: 'simple' })
        return axios.post('/api/convert', state)
            .then(response => {
                commit('load', response.data)
            })
    }
}

//mutations
const mutations = {
    /**
     * stateの一括更新
     * @param {Object} state 
     * @param {Object} n 
     */
    load(state, n) {
        state = Object.assign(state, n)
    },
    /**
     * stateの項目を指定して更新
     * @param {Object} state 
     * @param {Object} values 項目名をキーに、更新後の値をvalueに持つObject
     */
    update(state, values) {
        Object.keys(values).forEach(key => {
            Vue.set(state, key, values[key])
        })
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}